import script from "./OCriarEvento.vue?vue&type=script&lang=ts&setup=true"
export * from "./OCriarEvento.vue?vue&type=script&lang=ts&setup=true"

import "./OCriarEvento.vue?vue&type=style&index=0&id=19c4cdfd&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19c4cdfd"]])

export default __exports__